import { render, staticRenderFns } from "./FeatureItem.vue?vue&type=template&id=43b42557&scoped=true&"
import script from "./FeatureItem.vue?vue&type=script&lang=js&"
export * from "./FeatureItem.vue?vue&type=script&lang=js&"
import style0 from "./FeatureItem.vue?vue&type=style&index=0&id=43b42557&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b42557",
  null
  
)

export default component.exports